// Import MUI Components
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";

//Import router
import { Link } from "react-router";

//Imports Icons MUI
import GridViewIcon from "@mui/icons-material/GridView";
import TableViewIcon from "@mui/icons-material/TableView";
import AssignmentAddIcon from "@mui/icons-material/AssignmentAdd";

export default function PanelButtonGestion({
	link,
	color,
	icon,
	name,
	affichageData,
	handleAffichageData,
}) {
	return (
		<Stack
			direction="row"
			justifyContent={"space-between"}
			spacing={1}
			alignItems={"center"}
		>
			<ToggleButtonGroup
				size="small"
				exclusive
				color="primary"
				value={affichageData}
				onChange={handleAffichageData}
			>
				<ToggleButton
					value="table"
					sx={{ p: "3px 5px" }}
				>
					<TableViewIcon />
				</ToggleButton>
				<ToggleButton
					sx={{ p: "3px 5px" }}
					value="grid"
				>
					<GridViewIcon />
				</ToggleButton>
			</ToggleButtonGroup>

			<Link to={link}>
				<Button
					size="small"
					color={color ? color : "primary"}
					variant="outlined"
					startIcon={icon ? icon : <AssignmentAddIcon />}
					sx={(theme) => ({
						[theme.breakpoints.down("sm")]: { fontSize: 11 },
					})}
				>
					{name}
				</Button>
			</Link>
		</Stack>
	);
}
